 const apiUrl = "https://ns.frothcrm.com/pool/public/api/"
// const apiUrl = "http://localhost/robotico/Froth_CRM_Support_L1/pool/public/api/"

const statusColors = {
    New: 'rgb(126 82 227 / 67%)',
    Open: 'rgb(126 82 227 / 67%)',
    Pending: 'rgb(191 82 82 / 82%)',
    Rejected: 'rgb(191 82 82 / 82%)',
    Cancelled: 'rgb(191 82 82 / 82%)',
    Resolved: 'rgb(91 182 110 / 65%)',
    Closed: 'rgb(91 182 110 / 65%)',
    Default: 'rgb(180, 180, 180)',
  };
  

export {
    apiUrl,statusColors
}